import { inject, Injectable } from '@angular/core';
import { ModulePermissionsDto, ProfileDto } from '@core/dtos/profile.dto';
import {
  ModulePermission,
  Profile,
} from '@core/interfaces/entities/profile.interface';
import { Mapper } from './mapper';
import { ModulePermissionsMapper } from './module-permissions.mapper';

/**
 * Mapper para convertir entre la entidad Profile de la API
 * y el DTO de Profile utilizado en el Cliente.
 *
 * @extends {Mapper<Profile, ProfileDto>}
 */
@Injectable({ providedIn: 'root' })
export class ProfileMapper extends Mapper<Profile, ProfileDto> {
  private modulePermissionsMapper: ModulePermissionsMapper =
    inject(ModulePermissionsMapper);

  /**
   * Mapea un objeto de la entidad 'Profile' que proviene de la API
   * a un 'ProfileDto' para ser usado en el Cliente.
   *
   * @param data El objeto de la entidad 'Profile' a mapear.
   * @returns Un Dto de 'ProfileDto' listo para ser usado en el Cliente.
   */
  mapFrom(data: Profile): ProfileDto {
    const modulePermissions: ModulePermission[] =
      data.profile_module_permissions || [];
    if (modulePermissions.length === 0) {
      return {
        id: data.id,
        name: data.name,
      };
    }

    const mappedModulePermissions: ModulePermissionsDto =
      this.modulePermissionsMapper.mapFrom(modulePermissions);

    return {
      id: data.id,
      name: data.name,
      modulePermissions: mappedModulePermissions,
    };
  }
}
